import React, { FunctionComponent } from 'react';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { Dealer } from '../../../types/dealerTypes';

import { emailValidatorFunction } from '../../../utils/validation';
import { Radio } from '../../Input/Radio/Radio';
import { TextField } from '../../Input/TextField/TextField';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import styles from '../styles.module.scss';
import { DealerLaunchStepProps } from '../types';
import { addOnlineDealNotificationDefaults } from '../defaults';

export const DealerLaunchOnlineDealNotification: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({
    defaultValues: addOnlineDealNotificationDefaults(dealer),
  });
  const isEnabledTextField = form.watch('wizard.updateEmails.enabled');

  return (
    <DealerLaunchFormCardLayout
      className={styles.widgetsStep}
      form={form}
      title="Online Deal Notifications"
      subTitle="Upstart Auto Retail can send update notifications when an online shopper makes a change to an existing deal they've built in Upstart Auto Retail. This is optional, but is strongly encouraged to avoid overlooking activity associate with existing leads."
      cardTitle="Do You Want To Enable Online Deal Notifications?"
      prevStep={prevStep}
      onFormSubmit={nextStep}
      nextLabel="Save & Continue"
    >
      <Radio
        className="flex-column"
        name="wizard.updateEmails.enabled"
        options={[
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ]}
        form={form}
      />
      {isEnabledTextField && (
        <div className={styles.widgetPreviewContainer}>
          <h1>Who should be alerted to online deal updates?</h1>
          <TextField
            label="Online Deal Notification Email"
            name="wizard.updateEmails.recipientEmail"
            tooltip="Use an email that is actively monitored; this is typically a BDC (if applicable or a GSM)."
            width="md"
            form={form}
            validation={{ required: true, validate: emailValidatorFunction }}
          />
        </div>
      )}
    </DealerLaunchFormCardLayout>
  );
};
